import { EMPTY_STRING } from '@src/core/config';

export const arcToFixed = (value?: number | string, precision?: number) => {

  const target = Number(value);

  if (isNaN(target)) return EMPTY_STRING;

  if (target % 1 !== 0) return target.toFixed(precision ?? 2);

  return target.toString();
};